import { createNode } from '@glueapp/graph-types';

export const NumberToText = createNode({
    id: 'Number To Text',
    name: 'Number To Text',
    category: 'Conversion',
    description: 'A Node for converting a number into a text',
    aiDescription:
        'Converts a number to its text (string) representation. Connect a number to the "Number" input port; the "Text" output port provides the string result.',
    color: '#5aaa92',
    integration: undefined,
    inPorts: {
        Number: {
            kind: 'number',
        },
    },
    outPorts: {
        Text: {
            kind: 'string',
        },
    },
    execute: function (input) {
        return { output: { Text: String(input.inPorts.Number) } };
    },
});
